// extracted by mini-css-extract-plugin
module.exports = {"mobileSmall":"20.625em","mobile":"23.438em","small":"36em","tablet":"48em","tablethori":"64em","desktop":"75em"};